import { css } from "@emotion/react";

export const readMore = css`
  color: rgba(255, 255, 255, 0);
  font-size: 1.3em;
  position: absolute;
  top: 42%;
  left: -20px;
  right: 0;
  bottom: 0;
  transition: all 0.3s linear;
  -webkit-transition: all 0.3s linear;
  -moz-transition: all 0.3s linear;
`;

export const icon = css`
  position: relative;
  top: 1px;
`;
